<template>
    <main class="m-contact">
        <y-container
            v-if="!$wait.is('loading-page')"
        >
            <div
                v-if="content.title"
                class="m-contact__title"
            >
                <svg
                    width="29"
                    height="32"
                    viewBox="0 0 29 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M27.608 21.9251L19.0587 30.4744C18.3307 31.2024 17.136 31.2024 16.408 30.4744C15.68
                    29.7464 15.68 28.5517 16.408 27.8237L21.784 22.4664H2.80002C1.77335 22.4664 0.93335
                    21.6264 0.93335 20.5997V1.93307C0.93335 0.906406 1.77335 0.0664062 2.80002 0.0664062C3.82668
                    0.0664062 4.66668 0.906406 4.66668 1.93307V18.7331H21.784L16.408 13.3757C15.68 12.6477 15.68
                    11.4531 16.408 10.7251C17.136 9.99707 18.3307 9.99707 19.0587 10.7251L27.608 19.2744C28.336
                    20.0024 28.336 21.1971 27.608 21.9251Z"
                        fill="#E12179"
                    />
                </svg>
                <h3
                    v-html="titleText"
                />
            </div>
            <p
                v-if="content.synopsis"
                class="m-contact__subtitle"
            >
                {{ content.synopsis }}
            </p>
            <y-row>
                <y-col md="7">
                    <img
                        class="m-contact__image"
                        :src="imgSrc(content.image)"
                        :alt="$t('contact.title')"
                    >
                    <y-row>
                        <y-col
                            md="4"
                            size="6"
                            class="phone"
                        >
                            <div
                                v-if="$settings(`contact_details.elements.0.fixed_tel.${$i18n.locale}.0`)"
                                class="m-contact__contact-item"
                            >
                                <img
                                    src="@modules/contact/assets/phone.svg"
                                    class="contact-item-icon"
                                    :alt="$t('contact.icon.phone')"
                                >
                                <a
                                    :class="`m-contact__contact-item__link phone ${$i18n.locale}`"
                                    :href="`tel:${$settings(`contact_details.elements.0.fixed_tel.${$i18n.locale}.0`)}`"
                                >
                                    {{ digits($settings(`contact_details.elements.0.fixed_tel.${$i18n.locale}.0`), $i18n.locale) }}
                                </a>
                            </div>
                        </y-col>
                        <y-col
                            md="4"
                            size="6"
                            class="fax"
                        >
                            <div
                                v-if="$settings(`contact_details.elements.0.fax.${$i18n.locale}.0`)"
                                class="m-contact__contact-item"
                            >
                                <img
                                    src="@modules/contact/assets/fax.svg"
                                    class="contact-item-icon"
                                    :alt="$t('contact.icon.fax')"
                                >

                                <a
                                    :class="`m-contact__contact-item__link fax ${$i18n.locale}`"
                                    :href="`fax:${$settings(`contact_details.elements.0.fax.${$i18n.locale}.0`)}`"
                                >
                                    {{ digits($settings(`contact_details.elements.0.fax.${$i18n.locale}.0`), $i18n.locale) }}
                                </a>
                            </div>
                        </y-col>
                        <y-col
                            md="4"
                            size="12"
                            class="email email-margin"
                        >
                            <div
                                v-if="$settings(`contact_details.elements.0.email.${$i18n.locale}.0`)"
                                class="m-contact__contact-item"
                            >
                                <img
                                    src="@modules/contact/assets/envelop.svg"
                                    class="contact-item-icon"
                                    :alt="$t('contact.icon.evenlop')"
                                >
                                <a
                                    :class="`m-contact__contact-item__link email ${$i18n.locale}`"
                                    :href="`mailto:${$settings(`contact_details.elements.0.email.${$i18n.locale}.0`)}`"
                                >
                                    {{ digits($settings(`contact_details.elements.0.email.${$i18n.locale}.0`), $i18n.locale) }}
                                </a>
                            </div>
                        </y-col>
                        <y-col class="work-time">
                            <div
                                v-if="$settings(`contact_details.elements.0.working_time.${$i18n.locale}`)"
                                class="m-contact__contact-item"
                            >
                                <img
                                    src="@modules/contact/assets/calendar.svg"
                                    :alt="$t('contact.icon.calendar')"
                                >
                                <span :class="`m-contact__contact-item__link envelope ${$i18n.locale}`">
                                    {{ digits($settings(`contact_details.elements.0.working_time.${$i18n.locale}`), $i18n.locale) }}
                                </span>
                            </div>
                        </y-col>
                    </y-row>
                </y-col>
                <y-col
                    :key="forceRerender"
                    md="5"
                >
                    <div class="m-contact__fields-wrapper">
                        <y-input
                            v-if="configs.commenting_name !== 'no_receive'"
                            v-model="model.name"
                            name="your_name"
                            :placeholder="$t('fields.your_name')"
                        />
                        <y-input
                            v-if="configs.commenting_email !== 'no_receive'"
                            v-model="model.email"
                            name="your_email"
                            :placeholder="$t('fields.your_email')"
                        />
                        <y-phone
                            v-if="configs.commenting_mobile !== 'no_receive'"
                            v-model="model.mobile"
                            name="mobile"
                            :placeholder="$t('fields.mobile')"
                            :translations="{
                                countrySelectorLabel: $t('fields.country_selector_label'),
                                countrySelectorError: $t('fields.country_selector_error'),
                                phoneNumberLabel: $t('fields.phone_number_label'),
                                example: $t('fields.example')
                            }"
                            no-example
                            clearable
                            @update="onUpdateMobile"
                        />
                        <y-textarea
                            v-if="configs.commenting_text !== 'no_receive'"
                            v-model="model.text"
                            name="message"
                            rows="8"
                        />

                        <y-button
                            flat
                            block
                            color="primary"
                            loading-on="saving-contact-form"
                            class="form-action"
                            size="medium"
                            @click.prevent="beforeSubmit"
                        >
                            {{ $t('buttons.submit') }}
                        </y-button>
                    </div>
                </y-col>
            </y-row>

            <y-recaptcha
                ref="recaptcha"
                :site-key="configs.recaptcha.key"
                :size="configs.recaptcha.size"
                @verify="afterVerify"
            />
        </y-container>
    </main>
</template>

<script>
    // Mixins
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import { digits } from '@groot-nodes/helpers/number';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    import {
        YInput, YTextarea, YRecaptcha, YPhone,
    } from '@groot-components/all';

    export default {
        name: 'Contact',

        components: {
            YInput,
            YPhone,
            YTextarea,
            YRecaptcha,
        },

        mixins: [PageMixin],

        /**
         * @inheritdoc
         */
        data() {
            return {
                forceRerender: 0,
                content      : '',
                configs      : null,
                model        : {},
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.content.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.content.seo_meta_description,
                    },
                ],
            };
        },

        /**
         *
         * @inheritDoc
         */
        computed: {
            /**
             * Return colored title
             *
             * @returns {string}
             */
            titleText() {
                return this.content.title
                    .replace(/\$(.*?)\$/g, '<span class="title-text-color">$1</span>');
            },
        },

        methods: {
            digits,
            removeSymbol,

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * Update phone component
             *
             * @param {object} value
             */
            onUpdateMobile(value) {
                if (value.nationalNumber) {
                    this.model.mobile = value.nationalNumber;
                    this.model.country_code = `+${value.countryCallingCode}`;
                }
            },

            /**
             * Fetch form config
             *
             * @returns {*}
             */
            fetch() {
                const content = this.$services.Content.postSingle({
                    type     : 'pages',
                    slug     : 'contact-us',
                    including: ['title', 'synopsis', 'image', 'seo_canonical', 'seo_meta_description', 'seo_post_title'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                const form = this.$services.Commenting.getFormConfig({
                    type  : 'pages',
                    slug  : 'contact-us',
                    locale: this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([content, form]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.content = responses[0].data.results;
                    }

                    if (this.handleReq(responses, 1)) {
                        this.configs = {
                            ...responses[1].data.results,
                            recaptcha: responses[1].data.metadata.recaptcha,
                            payload  : responses[1].data.metadata.payload,
                        };
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },

            /**
             * Verify recaptcha
             * Check recaptcha is active
             */
            beforeSubmit() {
                this.$wait.start('saving-contact-form');
                if (this.configs?.recaptcha?.active === '1') {
                    this.$refs.recaptcha.verify();
                } else {
                    this.save();
                }
            },

            /**
             * Set token and start Sending Comment
             *
             * @param {string} token
             */
            afterVerify(token) {
                this.model['g-recaptcha-response'] = token;
                this.save();
            },

            /**
             * Do send comment
             *
             * @returns {object}
             */
            save() {
                const model = {
                    email                 : this.model.email,
                    'g-recaptcha-response': this.model['g-recaptcha-response'],
                    name                  : this.model.name,
                    text                  : this.model.text,
                    mobile                : {
                        country_code: `${this.model.country_code || 1}`,
                        mobile      : this.model.mobile || '',
                    },
                };
                return this.$services.Commenting.commentSave({
                    ...model,
                    slug  : 'contact-us',
                    type  : 'pages',
                    locale: this.$i18n.locale,
                }).then(() => {
                    this.model = {};
                    this.forceRerender += 1;
                    this.$toast.success(this.$t('comments.message.success'));
                }).catch((error) => {
                    this.handleError(error);
                }).finally(() => {
                    this.$wait.end('saving-contact-form');
                    this.$refs.recaptcha?.reset();
                });
            },
        },
    };
</script>

<style lang="scss" src="../scss/contact.scss" />
